import BaseLineSeries from "./private/BaseLineSeries.js";
import AnimatedPath from "./private/AnimatedPath.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AnimatedLineSeries(props) {
  return /*#__PURE__*/_jsx(BaseLineSeries, {
    ...props,
    PathComponent: AnimatedPath
  });
}